const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  MAPBOX_ACCESS_TOKEN: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || ''
};

export default config;
